import React from "react";
import styled from "styled-components";
import LSRgH1HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";

import useDisplay from "../../../hooks/useDisplay";

import LSRgCaption02 from "../../molecules/text/linSeedKr/Rg/lsRgCaption02";

const Radio = ({
  // isSmall,
  id,
  checked,
  name,
  value,
  valueText,
  onChange,
  style,
  textStyle,
}) => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile;

  return (
    <RadioLabel
      htmlFor={id}
      style={{
        height: isMobile ? 14 : 22,
        ...style,
      }}
      checked={checked}
    >
      <RadioBoxIcon
        isSmall={isSmall}
        src={
          checked ? "/assets/icons/radio_a.png" : "/assets/icons/radio_d.png"
        }
        alt={checked ? "체크됨" : "체크되지 않음"}
      />

      {isSmall && (
        <LSRgCaption02
          style={{ color: "#101113", height: "14px", ...textStyle }}
        >
          {valueText}
        </LSRgCaption02>
      )}

      {!isSmall && (
        <LSRgH1HeadLine
          style={{ color: "#101113", height: "22px", ...textStyle }}
        >
          {valueText}
        </LSRgH1HeadLine>
      )}

      <RadioInput
        type="radio"
        value={value}
        name={name}
        id={id}
        checked={checked}
        onChange={onChange}
      />
    </RadioLabel>
  );
};

export default Radio;

const RadioLabel = styled.label.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;

const RadioBoxIcon = styled.img.attrs((props) => {})`
  width: ${(props) => (props.isSmall ? "14px" : "16px")};
  height: ${(props) => (props.isSmall ? "14px" : "16px")};

  object-fit: cover;
`;

const RadioInput = styled.input.attrs((props) => {})`
  display: none;
`;
